module.exports = __webpack_public_path__ + "static/media/chart.22dde1ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/chart.png
 ** module id = 586
 ** module chunks = 0
 **/